module.exports = __webpack_public_path__ + "static/media/portfolio-2.750f45a8.jpg";